export const isBrowser = () => typeof window !== "undefined"

export const getUser = () =>
  isBrowser() && window.localStorage.getItem("gatsbyUser")
    ? JSON.parse(window.localStorage.getItem("gatsbyUser"))
    : {}

const setUser = user =>
  window.localStorage.setItem("gatsbyUser", JSON.stringify(user))

export const handleLogin = ({ email, token }) => {
  
  if (token) {
    let firstLetter = email.slice(0,1);
    return setUser({
      token: token,
      email: email,
      firstLetter: firstLetter,
    })
  }

  return false
}

export const isLoggedIn = () => {
  const user = getUser()

  return !!user.token
}

export const logout = callback => {
  setUser({})
  callback()
}